export default defineNuxtPlugin(() => {
  const { trackApiError, track } = usePostHog()

  // Track unhandled JavaScript errors
  window.addEventListener('error', (event) => {
    track('javascript_error', {
      error_message: event.message,
      error_filename: event.filename,
      error_line: event.lineno,
      error_column: event.colno,
      error_stack: event.error?.stack,
      user_agent: navigator.userAgent,
      page_url: window.location.href,
    })
  })

  // Track unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    track('unhandled_promise_rejection', {
      error_message: event.reason?.message || String(event.reason),
      error_stack: event.reason?.stack,
      user_agent: navigator.userAgent,
      page_url: window.location.href,
    })
  })

  // Track Vue errors via Nuxt's error handler
  const nuxtApp = useNuxtApp()
  
  nuxtApp.hook('vue:error', (err: unknown, instance: any, info: string) => {
    const error = err as Error
    track('vue_error', {
      error_message: error.message || String(err),
      error_stack: error.stack,
      vue_component: instance?.$options?.name || instance?.name || 'unknown',
      error_info: info,
      user_agent: navigator.userAgent,
      page_url: window.location.href,
    })
  })

  // Enhance console.error to track critical errors
  const originalConsoleError = console.error
  console.error = (...args) => {
    // Call original console.error
    originalConsoleError.apply(console, args)
    
    // Track error if it looks important
    const errorMessage = args.map(arg => 
      typeof arg === 'object' ? JSON.stringify(arg) : String(arg)
    ).join(' ')
    
    if (errorMessage.includes('API') || 
        errorMessage.includes('Failed') || 
        errorMessage.includes('Error')) {
      track('console_error', {
        error_message: errorMessage,
        user_agent: navigator.userAgent,
        page_url: window.location.href,
      })
    }
  }

  console.log('[PostHog] Error tracking initialized')
})
